import { Button, Layout, Loading, Page } from '@shopify/polaris'
import React from 'react'

import { Footer } from '../common/Footer'
import { LoadErrorPage } from '../common/LoadErrorPage'
import { TabIndex, Tabs } from '../common/Tabs'
import { customerPortalTranslationsUrl } from '../common/urls'
import { CustomerPortalSettings, useCustomerPortalSettings } from './api'
import { CustomerPortalSettingsForm } from './CustomerPortalSettingsForm'
import { SkeletonPage } from './SkeletonPage'

const LoadedPage = ({ initialValues }: { initialValues: CustomerPortalSettings }) => (
  <Page
    title="Customer Portal Settings"
    primaryAction={<Button url={customerPortalTranslationsUrl()}>Manage translations</Button>}
  >
    <CustomerPortalSettingsForm initialValues={initialValues} />
    <Layout.Section>
      <Footer />
    </Layout.Section>
  </Page>
)

export const CustomerPortalSettingsPage = () => {
  const { data, error, isValidating } = useCustomerPortalSettings()

  return (
    <>
      {isValidating && <Loading />}
      <Tabs selected={TabIndex.CustomerPortalSettings} />

      {error && <LoadErrorPage />}
      {!error && !data && <SkeletonPage title="Customer Portal Settings" />}
      {!error && data && <LoadedPage initialValues={data} />}
    </>
  )
}
